// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-link-container.is-underline:hover:after{content:\"\";position:absolute;left:0;right:0;height:0;bottom:0;border-width:1px;border-style:solid;border-color:inherit}", ""]);
// Exports
module.exports = exports;
